import { Container } from '@/atoms';
import { StepperWordpress } from '@/templates';

/**
 * Stepper
 */
export const Stepper = ({ bloque, id }: any) => (
  <Container
    id={id}
    wrapper
    as="section"
    padding="px-4 py-8"
    backgroundColor={bloque.background ? `bg-${bloque.background}` : undefined}
  >
    <StepperWordpress stepper={bloque} />
  </Container>
);

export default Stepper;
Stepper.displayName = 'FlexibleStepper';
